import React from 'react';
import Form from './Form';
import { Page, PageTitle, Panel } from '../Page';

const Login = () => (
  <Page>
    <PageTitle>Log in</PageTitle>
    <Panel>
      <Form />
    </Panel>
  </Page>
);

export default Login;
